<template>
    <v-window-item value="maintenances">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Maintainances</h2>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                        :headers="compnentsHeaders"
                        :items="maintainancesData"
                        :loading="loading"
                        :hover="true"
                        density="compact"
                        elevation="0"
                        class="border-sm rounded-md"
                    >
                    
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>

export default {
    props: {
        maintainancesData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {},
    data: () => ({
        dialog: false,
        loading: false,
        compnentsHeaders: [
            { title: "Location", key: "asset_maintenance.asset_location.name", align: "center", sortable: false },
            { title: "Maintainance Date", key: "asset_maintenance.maintenance_date", align: "center", sortable: false },
            { title: "Supplier", key: "asset_maintenance.supplier.name", align: "center", sortable: false },
            { title: "Reference No", key: "asset_maintenance.reference_no" || "-", align: "center", sortable: false },
            { title: "Start Date", key: "start_date", align: "center", sortable: false },
            { title: "Next Maintainance Date", key: "end_date", align: "center", sortable: false },
            { title: "Cost", key: "cost", align: "end", sortable: false },
            { title: "Issue", key: "issue_description", align: "center", sortable: false },
            { title: "Action Taken", key: "action_taken", align: "center", sortable: false },
            
        ],
    }),
    computed: {},
    watch: {},
    created() {},
    methods: {},
    setup(props, {emit}){},
    mounted() {
        
    },
}
</script>